import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AppComponent } from '../app.component';
import { ApiRestService } from '../services/api-rest.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
declare var $: any;



@Component({
  selector: 'app-password-new',
  templateUrl: './password-new.component.html',
  styleUrls: ['./password-new.component.css']
})
export class PasswordNewComponent implements OnInit {

config: any;
newpassForm : FormGroup;
response = {
    success: false,
    error: "",
    status: false
  };

  model = {
    password:"",
    passconfirm:""
  };
  password:string;
	token = "";
	click : boolean = true;
	showError : boolean = false;
  showForm: any;

  constructor(
  		private appComponent: AppComponent,
  	  	private apiRestService: ApiRestService,
  	  	private formBuilder: FormBuilder,
  	  	private router: Router,
  	  	private fb: FormBuilder,
        private route: ActivatedRoute
  
  	) {
  		this.config = this.appComponent.config;
  		
  	 }

    ngOnInit(): void {
      this.token = this.route.snapshot.paramMap.get("token");
      this.verifyToken();

      var vthis = this;
        
  }

 form(){
  var vthis = this;
  this.newpassForm = this.fb.group({
           password: new FormControl('',  [Validators.required, Validators.minLength(6)]),
           passconfirm: new FormControl('', [Validators.required, Validators.minLength(6)])
        });
        if(this.newpassForm.valid) {
          vthis.click = false;
        }
 }

  newpass(){
    var vthis = this;
   

      if(this.newpassForm.valid){
        const login = {
          password: this.newpassForm.value.password,
          token: this.token,
        };
        const options = {
                    withCredentials: true
                };
        this.apiRestService.request('resetpassword', login, options).subscribe((response) => {
          Object.assign(this.response, response);
          console.log(this.response);
          if(this.response.success){
              $('#myModal').modal('show');
              $('#myModal').on('hidden.bs.modal', function (e) {
                   vthis.router.navigate(['/login']);
               }); 
          }else{
           this.showError = true;
          }
        });
      }
      
    



  }

  verifyToken(){
    var vthis = this;
      
        const login = {
          activation_code: this.token
        };
        const options = {
                    withCredentials: false
                };
        this.apiRestService.request('verifyCodeReset', login, options).subscribe((response) => {
          Object.assign(this.response, response);
          /*this.response.success = true;*/
          console.log(this.response);
          if(this.response.status){
              vthis.showForm = 1;
              vthis.form();
          }else{
           vthis.showForm = 2;
          }
        });
      
      
    



  }

}
